import React, { useState, useCallback } from 'react'
import WashCreateNewReportOverlay from './WashCreateNewReportOverlay'
import WashReportTypeList from './WashReportTypeList'


const WashReports = () => {
  const [showCreateOverlay, setShowCreateOverlay] = useState(false)
  const [createNewReportType, setCreateNewReportType] = useState(false)

  const handleClickCreateNewReport = useCallback((reportType) => {
    setCreateNewReportType(reportType)
    setShowCreateOverlay(true)
  }, [])

  const onCloseOverlayClick = () => {
    setShowCreateOverlay(false)
  }

  return (
    <div>
      <WashReportTypeList onClickCreateNewReport={handleClickCreateNewReport} />
      <WashCreateNewReportOverlay visible={showCreateOverlay} onClose={onCloseOverlayClick}
        reportTypeId={createNewReportType.id} reportTypeName={createNewReportType.displayName} />
    </div >
  )
}

export default WashReports
